import React from "react";
import { BnbLabel, useBnbOptionalLabel } from "../../../../utils/labels";
import * as FinanceToggleStyles from "../../../../../../../common-deprecated/styles/v2/toyota/components/FinanceToggle";
import * as Styles from "./styles/BasketFinanceTogglePanelStyles";
import Preloader, * as PreloaderStyles from "../../../../../../../common-deprecated/styles/v2/toyota/custom/Preloader";
import * as BasketStyles from "../../../../../../../common-deprecated/styles/v2/toyota/custom/basket/Basket";
import useFinanceToggle from "../../../../hooks/shared/actions/useFinanceToggle";
import { useBnbSelector } from "../../../../redux/store";
import Price from "../price/Price";
import FinanceQuotes from "../FinanceQuotes";
import BasketCtas from "../basket/content/BasketCtas";
import TotalPriceDisclaimers from "../price/TotalPriceDisclaimers";
import { isRTL } from "../../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import Spacer from "../../../../../../../common-deprecated/styles/v2/toyota/utilities/Spacer";
import { showPrice } from "../../../../../../../common-deprecated/settings/utils/financeSettingUtilsCommon";

const BasketFinanceTogglePanel = (): JSX.Element | null => {
    const totalPrice = useBnbSelector((state) => state.basket.total);
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const step = useBnbSelector(({ navigation }) => navigation.step);
    const modelCode = useBnbSelector((state) => state.car.model.internalCode);
    const showPrices = showPrice(commonSettings);

    const financeToggleProps = useFinanceToggle();
    const { setCash, setMonthly } = financeToggleProps;
    const { showMonthlyRateToggle, showCashPrice } = financeToggleProps;
    const { showCashLoader, showMonthlyLoader, showToggles, financeOption } = financeToggleProps;

    const [selectedFinanceOptionTitle, basketTotalMonthlyCosts] = useBnbOptionalLabel([
        "selectedFinanceOptionTitle",
        "basketTotalMonthlyCosts",
    ]);

    return (
        <>
            {showToggles && showMonthlyRateToggle && (
                <FinanceToggleStyles.Wrapper fullWidth isMonthlyActive={financeOption === "monthly"}>
                    <FinanceToggleStyles.ToggleItem
                        onClick={() => {
                            if (financeOption === "cash") return;
                            setCash();
                        }}
                    >
                        <FinanceToggleStyles.LineClamp>
                            <BnbLabel label="financeOptionTitleCash" fallbackLabel="financeOptionCash" useHTML />
                        </FinanceToggleStyles.LineClamp>
                    </FinanceToggleStyles.ToggleItem>
                    <FinanceToggleStyles.ToggleItem
                        onClick={() => {
                            if (financeOption === "monthly") return;
                            setMonthly();
                        }}
                    >
                        <FinanceToggleStyles.LineClamp>
                            <BnbLabel label="financeOptionTitleMonthly" fallbackLabel="financeOptionMonthly" useHTML />
                        </FinanceToggleStyles.LineClamp>
                    </FinanceToggleStyles.ToggleItem>
                </FinanceToggleStyles.Wrapper>
            )}
            {financeOption === "cash" ? (
                showCashLoader ? (
                    <PreloaderStyles.PreLoaderWrapper hasButtonHeight mt={3}>
                        <Preloader size={30} />
                    </PreloaderStyles.PreLoaderWrapper>
                ) : (
                    showPrices && (
                        <Spacer mt={2}>
                            {showMonthlyRateToggle && (
                                <Styles.PriceDetailsList isRTL={isRTL(commonSettings)}>
                                    {!!selectedFinanceOptionTitle && <dt>{selectedFinanceOptionTitle}</dt>}
                                    <li>
                                        <BnbLabel
                                            label="financeOptionTitleCash"
                                            fallbackLabel="financeOptionCash"
                                            useHTML
                                        />
                                    </li>
                                </Styles.PriceDetailsList>
                            )}
                            {showCashPrice && (
                                <Styles.PriceDetailsList isRTL={isRTL(commonSettings)}>
                                    <li>
                                        <BnbLabel label="basketTotal" />
                                    </li>
                                    <li>
                                        <Price
                                            price={totalPrice}
                                            financeItemId="total"
                                            forceHideMonthlyDisclaimer
                                            showLoader
                                        />
                                    </li>
                                </Styles.PriceDetailsList>
                            )}
                        </Spacer>
                    )
                )
            ) : showMonthlyLoader ? (
                <PreloaderStyles.PreLoaderWrapper hasButtonHeight mt={3}>
                    <Preloader size={30} />
                </PreloaderStyles.PreLoaderWrapper>
            ) : (
                <Spacer mt={2}>
                    <Styles.PriceDetailsList isRTL={isRTL(commonSettings)}>
                        {!!selectedFinanceOptionTitle && <li>{selectedFinanceOptionTitle}</li>}
                        <li>
                            <BnbLabel label="financeOptionTitleMonthly" fallbackLabel="financeOptionMonthly" useHTML />
                        </li>
                    </Styles.PriceDetailsList>
                    <Styles.PriceDetailsList isRTL={isRTL(commonSettings)}>
                        {!!basketTotalMonthlyCosts && <li>{basketTotalMonthlyCosts}</li>}
                        <li>
                            <Price
                                price={totalPrice}
                                financeOption="monthly"
                                financeItemId="total"
                                carInternalCode={modelCode}
                            />
                        </li>
                    </Styles.PriceDetailsList>
                    <BasketStyles.FinanceQuotesWrapper>
                        <FinanceQuotes />
                    </BasketStyles.FinanceQuotesWrapper>
                </Spacer>
            )}

            <TotalPriceDisclaimers />

            <BasketCtas step={step} financeOption={financeOption} />
        </>
    );
};

export default BasketFinanceTogglePanel;
